<template>
  <div class="main">
    <div class="topImg"><img src="../assets/scanSuccess.png" alt=""></div>
    <div class="scanSucc">支付成功</div>
    <div class="bgLine"></div>
    <div class="BommainBox">
      <div class="Bommain">
      <div class="topNmae" v-if="userinfo && userinfo.name">{{ userinfo.name }}</div>
      <div class="topUnip" v-if="userinfo && userinfo.mainOrg">{{ userinfo.mainOrg }}</div>
      <div class="bomLine" v-if="orderDetail&&orderDetail.cCanteenName">
        <div class="bomLineLeft">食堂名称：</div>
        <div class="bomLineRight">{{orderDetail.cCanteenName}}</div>
      </div>
      <div class="bomLine" v-if="orderDetail&&orderDetail.cDetailedAddress">
        <div class="bomLineLeft">就餐地点：</div>
        <div class="bomLineRight">{{orderDetail.cDetailedAddress}}</div>
      </div>
      <div class="bomLine" v-if="orderDetail&&orderDetail.boAppointment">
        <div class="bomLineLeft">就餐时间：</div>
        <div class="bomLineRight">{{orderDetail.boAppointment}}</div>
      </div>
      <div class="bomLine" v-if="orderID>0">
        <div class="bomLineLeft">预约情况：</div>
        <div class="bomLineRight">有预约</div>
      </div>
      <div class="bomLine">
        <div class="bomLineLeft">支付金额：</div>
        <div class="bomLineRight" style="color: #EA6363;font-size: 16px;font-weight: bold;">{{mealFee}}</div>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script>
import qs from "qs";
import Vue from 'vue';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
export default {
  name: 'scanSuccess',
  data () {
    return {
      orderID:this.$route.query.oid,
      canteenID:this.$route.query.cid,
      orderDetail:'',
      userinfo:'',
      mealFee: this.$route.query.mealFee
    }
  },
  created(){
    this.orderID=this.$route.query.oid,
    this.canteenID=this.$route.query.cid,
    this.mealFee = this.$route.query.mealFee,
    this.getUserInfo();
    this.getOrderDetail()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.orderID=this.$route.query.oid,
    this.canteenID=this.$route.query.cid,
    this.mealFee = this.$route.query.mealFee
    this.getOrderDetail()
  },
  methods:{
    getUserInfo() {
      dd.getLoginUser()
        .then((res) => {
          this.userinfo = res;
        })
        .catch((err) => {
          // Dialog.alert({
          //   title: '提示',
          //   message: '获取用户信息失败，请重新登录',
          //   confirmButtonColor:'#3B87F5',
          //   cancelButtonColor:'#666666'
          // }).then(() => {
          //   // on close
          //   dd.closePage()
          // });
        });
    },
    getOrderDetail(){
      let orderDetail = {}
      let lock =0
      // if(this.orderID&&this.orderID>0){
      //   let param = {
      //     BookingOrderID:this.orderID-0,
      //   }
      //   this.$post('api/Order/GetBookingOrderInfo', qs.stringify(param),{
      //     headers:{
      //         'Content-Type': 'application/x-www-form-urlencoded'
      //     }
      //   }).then((res)=>{
      //     if(res.code==1000){
      //       orderDetail.boAppointment = res.data.boAppointment
      //       lock+=1
      //       if(lock>=2){
      //         this.orderDetail = orderDetail
      //       }
      //     }
      //   })
      // }else{
        lock+=1
        orderDetail.boAppointment = this.getnow()
      // }
      let param = {
        CanteenID:this.canteenID-0,
      }
      this.$post('api/Canteen/GetCanteenEntity', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          orderDetail.cCanteenName = res.data.cEntity.cCanteenName
          orderDetail.cDetailedAddress = res.data.cEntity.cDetailedAddress
          if(res.data.cEntity.cCanteenType=='食堂'){
            orderDetail.price = '-15'
          }else if(res.data.cEntity.cCanteenType=='廉政灶'){
            orderDetail.price = '-30'
          }else{
            orderDetail.price = '-15'
          }
          // lock+=1
          // if(lock>=2){
            this.orderDetail = orderDetail
          // }
        }
      })
    },
    getnow(dates){
      var mynow = dates?new Date(dates):new Date();//默认的获取的是当前时间
      //通过调用日期对象的方法来重新获取当前的日期时间
      //mynow.setFullYear(2016);
      var year = mynow.getFullYear();//获取年
      var month = (mynow.getMonth()+1)<10?'0'+(mynow.getMonth()+1):(mynow.getMonth()+1);//获取月
      var day = mynow.getDate()<10?'0'+mynow.getDate():mynow.getDate();//获取日
      var hour =mynow.getHours()<10?'0'+mynow.getHours():mynow.getHours();//获取小时
      var minute =mynow.getMinutes()<10?'0'+mynow.getMinutes():mynow.getMinutes();//获取分钟
      // var second =mynow.getSeconds();//获取秒
      var strdate = year+'-'+ month+"-"+day+' '+hour+':'+minute
      return strdate
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  box-sizing: border-box;
  padding: 50px 28px;
  min-height: 100vh;
  background:linear-gradient(to bottom,#3B87F5 0%,#fff 60%,#fff 60%,#fff 100%);
}
.topNmae{
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.topUnip{
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin-top: 12px;
  padding-bottom: 25px;
  border-bottom: 1px solid #E6E6E6;
  text-align: center;
}
.bomLine{
  display: flex;
  align-items: flex-start;
  margin: 15px 0;
}
.bomLineLeft{
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
.bomLineRight{
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-left: 6px;
  line-height: 18px;
  max-width: 64%;
}
.scanSucc{
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}
.topImg{
  width: 90px;
  height: 94px;
  margin: 0 auto 0;
}
.topImg>img{
  width: 100%;
  height: 100%;
}
.bgLine{
  height: 8px;
  background: #0855C4;
  border-radius: 4px;
  margin-top: 26px;
}
.BommainBox{
  box-sizing: border-box;
  padding: 0 8px;
  margin-top: -4px;
}
.Bommain{
  background: #FFFFFF;
  box-shadow: 0px 1px 4px 0px rgba(4, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 26px 28px 25px;
}
</style>



// WEBPACK FOOTER //
// src/page/scanSucess.vue